<script>
import api from '@/command/api'
import TemplateHeaderTable from '@/components/TemplateHeaderTable'
import { resourceHeaderConfig } from './config'
import ChangeLogModal from './components/ChangeLogModal'
import { getAction } from '@/command/netTool'
import { statusDict } from './config'
export default {
  name: 'resource',
  components: {
    ChangeLogModal
  },
  data() {
    return {
      ...api.command.getState(),
      paramsValue: {},
      changeLogVisible: false,
      currentResourceId: '',
      // 字典数据
      resourcesTypeList: [],
      landUseNatureList: [],
      recruitmentTypeList: []
    }
  },
  mounted() {
    // 获取字典数据
    this.loadDictData()

    api.command.getList.call(this, {
      url: '/farmHousingResources/page',
      current: 1
    })
  },
  methods: {
    // 加载字典数据
    loadDictData() {
      getAction(
        '/admin/dict/codes?codes=housing_resources_type,housing_land_use_nature,recruitment_type',
        {},
        '/bpi'
      ).then(res => {
        if (res.code == 200) {
          // 填充资源类型
          this.resourcesTypeList = (
            res.data['housing_resources_type'] || []
          ).map(item => ({
            name: item.name,
            value: item.id
          }))

          // 填充用地性质
          this.landUseNatureList = (
            res.data['housing_land_use_nature'] || []
          ).map(item => ({
            name: item.name,
            value: item.id
          }))

          this.recruitmentTypeList = (res.data['recruitment_type'] || []).map(
            item => ({
              name: item.name,
              value: item.id
            })
          )

          // 强制重新渲染
          this.$forceUpdate()
        }
      })
    },
    getHeader() {
      return [
        {
          name: '资源名称',
          type: 'input',
          key: 'name',
          placeholder: '请输入资源名称'
        },
        {
          name: '资源类型',
          type: 'select',
          key: 'resourcesType',
          placeholder: '请选择资源类型',
          dictType: 'housing_resources_type',
          typeData: this.resourcesTypeList
        },
        {
          name: '用地性质',
          type: 'select',
          key: 'landUseNature',
          placeholder: '请选择用地性质',
          dictType: 'housing_land_use_nature',
          typeData: this.landUseNatureList
        },
        {
          name: '审核状态',
          type: 'select',
          key: 'status',
          placeholder: '请选择审核状态',
          typeData: [{ name: '全部', value: '' }, ...statusDict]
        },
        {
          name: '上架状态',
          type: 'select',
          key: 'upDown',
          placeholder: '请选择上架状态',
          typeData: [
            { name: '全部', value: '' },
            { name: '上架', value: '0' },
            { name: '下架', value: '1' }
          ]
        }
      ]
    },

    getColumns() {
      return [
        ...resourceHeaderConfig.columns,
        {
          dataIndex: 'action',
          title: '操作',
          type: 'buttonGroup',
          align: 'center',
          fixed: 'right',
          typeData: ({ records }) => {
            const buttons = [
              {
                name: '查看',
                onClick: () =>
                  this.$router.push(
                    `/resourceManagement/resource/detail?id=${records.id}&type=view`
                  )
              }
            ]

            // 当status==2、4、5的时候都可以显示变更按钮
            if (['2', '4', '5'].includes(records.status)) {
              buttons.push({
                name: '变更',
                onClick: () =>
                  this.$router.push(
                    `/resourceManagement/resource/detail?id=${records.id}`
                  )
              })
            }

            // 只有当status==4的时候才显示上、下架按钮
            if (records.status == '4') {
              if (records.upDown == 0) {
                buttons.push({
                  name: '下架',
                  onClick: () => {
                    api.command.editGET.call(this, {
                      url: '/farmHousingResources/down',
                      params: { id: records.id }
                    })
                  }
                })
              } else {
                buttons.push({
                  name: '上架',
                  onClick: () => {
                    api.command.editGET.call(this, {
                      url: '/farmHousingResources/up',
                      params: { id: records.id }
                    })
                  }
                })
              }
            }

            buttons.push(
              {
                name: '删除',
                type: 'pop',
                popTitle: '确认删除吗?',
                onClick: () =>
                  api.command.del.call(this, {
                    url: '/farmHousingResources',
                    params: { ids: records.id }
                  })
              },
              {
                name: '变更记录',
                onClick: () => {
                  this.currentResourceId = records.id
                  this.changeLogVisible = true
                }
              }
            )

            return buttons
          }
        }
      ]
    },
    getButton() {
      return [
        {
          name: '添加',
          icon: 'plus',
          type: 'primary',
          onClick: () =>
            this.$router.push('/resourceManagement/resource/detail')
        },
        {
          viewType: 'menu',
          name: '更多操作',
          isBatch: true,
          children: [
            {
              name: '批量删除',
              onClick: data => {
                let ids = data.map(e => e.id).join(',')
                return api.command.del.call(this, {
                  url: '/farmHousingResources',
                  params: { ids }
                })
              }
            },
            {
              name: '批量上架',
              onClick: data => {
                let idList = data.map(e => e.id)
                return api.command.editGet.call(this, {
                  url: '/farmHousingResources/up',
                  params: { id: idList }
                })
              }
            },
            {
              name: '批量下架',
              onClick: data => {
                let idList = data.map(e => e.id)
                return api.command.editGet.call(this, {
                  url: '/farmHousingResources/down',
                  params: { id: idList }
                })
              }
            }
          ]
        }
      ]
    }
  },
  render() {
    return (
      <div>
        <TemplateHeaderTable
          headerData={this.getHeader()}
          tableColumns={this.getColumns()}
          button={this.getButton()}
          records={this.records}
        />
        <ChangeLogModal
          visible={this.changeLogVisible}
          resourceId={this.currentResourceId}
          onCancel={() => (this.changeLogVisible = false)}
        />
      </div>
    )
  }
}
</script>
